import React, { useContext } from "react";
import { LanguageContext } from "../languages/languageContext";
import LanguageTag from "./LanguageTag";
interface CourseItemProps {
  course: ICourse;
}

const CourseItem: React.FC<CourseItemProps> = ({ course }) => {
  const language_id = useContext(LanguageContext).id;

  return (
    <a target="_blank" href={course.link}>
      <article className="mb-5 p-4 transition duration-150 hover:bg-gray-200">
        <h3 className="mb-3 flex flex-col-reverse items-start gap-0 text-3xl text-gray-700">
          {course.title[language_id as keyof ICourse["title"]]}
        </h3>

        <div className="items-start gap-2 lg:flex">
          <div className="relative overflow-hidden rounded-lg lg:min-w-[400px] lg:max-w-[400px]">
            <LanguageTag language={course.language} />
            <img
              src={course.image}
              className="w-full lg:min-w-[400px] lg:max-w-[400px]"
            />
          </div>

          <div className="text-gray-600">
            <p className="my-3 text-lg text-gray-600 md:mt-0">
              {course.description[language_id as keyof ICourse["description"]]}
            </p>
            <div className="flex flex-wrap items-center gap-1 ">
              {course.stack.map((item, idx) => (
                <span
                  key={idx}
                  className="flex items-center gap-1 bg-gray-700 py-0 px-1 font-['Unica_One'] text-base text-white"
                >
                  <item.Icon />
                  <span className="ml-1">{item.name.toUpperCase()}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </article>
    </a>
  );
};

export default CourseItem;
